import { render, staticRenderFns } from "./BudgetContextMenu.vue?vue&type=template&id=5988ca85"
import script from "./BudgetContextMenu.vue?vue&type=script&lang=js"
export * from "./BudgetContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports